import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Input, Dropdown } from 'semantic-ui-react';
import TemplateName from './TemplateName';
import TemplateDescription from './TemplateDescription';
import ExceptCategoryBlock from '../Common/ExceptCategoryBlock';
import CountDayOfMenuBlock from '../Common/CountDayOfMenuBlock';
import {
  changeTemplateName,
  changeTemplateDescription,
  selectTemplateTagsFilters,
  changeTemplateMenuDays,
  changeTemplateSameDaysCount,
  generateTemplateMenu,
  saveTemplate,
  toggleTemplateEating,
  setMenuTemplateGenerator,
  setTemplateParametersCategories,
  setGenderValue,
  resetTemplateData,
} from '../../actions/templateGenerator';
import { getTags } from '../../actions/tags/getTags';
import { toastError } from '../../utils/toastMessage';
import TypeMenuBlock from '../Common/TypeMenuBlock';
import TemplateActions from './TemplateActions';
import ConfirmPopup from '../Common/ConfirmPopup';
import ChooseEatings from '../Common/ChooseEatings';
import {
  getDefaultMenu,
  CATEGORY_INGREDIENTS,
  TEMPLATE_PARAMETERS_TAG,
} from '../../constants/appConstants';
import API from '../../utils/API';
import TemplateGenerationValuesModal from './TemplateGenerationValuesModal';
import TemplateFolderSelection from './TemplateFolderSelection';
import { resetChoosedTemplate } from '../../actions/template';

const TemplateOptions = ({
  templateName,
  changeTemplateName,
  templateDescription,
  changeTemplateDescription,
  tags,
  templateTagsFilters,
  selectTemplateTagsFilters,
  getTags,
  countTemplateDays,
  changeTemplateMenuDays,
  changeTemplateSameDaysCount,
  templateSameDaysCount,
  generateTemplateMenu,
  saveTemplate,
  toggleTemplateEating,
  chosenTemplateEatings,
  loader,
  menuTemplateGenerator,
  setMenuTemplateGenerator,
  allEatingsTags,
  folders,
  setTemplateParametersCategories,
  templateParametersCategories,
  setGenderValue,
  resetTemplateData,
  resetChoosedTemplate,
  setMaxCalories,
  maxCalories = 0,
}) => {
  const [isShowRewriteTemplatePopup, setShowRewriteTemplatePopup] = useState(false);
  const [isOpenTemplateGenerationValues, setIsOpenTemplateGenerationValues] = useState(false);
  const [currentMenu, setCurrentMenu] = useState([]);
  const [currentTags, setCurrentTags] = useState([]);
  const [currentName, setCurrentName] = useState('');
  const [currentDescription, setCurrentDescription] = useState('');

  const toggleRewritePopup = () => setShowRewriteTemplatePopup(!isShowRewriteTemplatePopup);

  const checkIsTemplateAlreadyExists = () => {
    API.post('/templates/check', {
      title: templateName,
    })
      .then((response) => {
        if (response.data.alerts[0] === 'Ok') {
          saveTemplate();
          setCurrentMenu(JSON.stringify(menuTemplateGenerator));
          setCurrentTags(templateTagsFilters);
          setCurrentName(templateName);
          setCurrentDescription(templateDescription);
          return;
        }
        toggleRewritePopup();
      })
      .catch(() => {
        toastError();
      });
  };

  const onApplyRewrite = () => {
    toggleRewritePopup();
    saveTemplate();
    setCurrentTags(templateTagsFilters);
    setCurrentMenu(JSON.stringify(menuTemplateGenerator));
    setCurrentName(templateName);
    setCurrentDescription(templateDescription);
  };

  const onClearTemplateMenuBlock = () => {
    setMenuTemplateGenerator(getDefaultMenu());
  };

  const onChangeTemplateCountDays = (countDays) => {
    changeTemplateMenuDays(countDays);
    setMenuTemplateGenerator(getDefaultMenu(+countDays));
  };

  useEffect(() => {
    !tags.length && getTags();
    setCurrentMenu(JSON.stringify(menuTemplateGenerator));
    setCurrentTags(templateTagsFilters);
    setCurrentName(templateName);
    setCurrentDescription(templateDescription);
  }, []);

  const resetTemplate = () => {
    resetTemplateData();
    resetChoosedTemplate();
  };

  useEffect(() => {
    return () => resetTemplate();
  }, []);

  const isMenuCurrent = currentMenu === JSON.stringify(menuTemplateGenerator);
  const isTagsCurrent = currentTags === templateTagsFilters;
  const isDescriptionCurrent = currentDescription === templateDescription;
  let isNameCurrent = !templateName.length;
  let disableSaveBtn = isNameCurrent;
  if (currentName.length) {
    isNameCurrent = currentName === templateName;
    disableSaveBtn = isNameCurrent && isMenuCurrent && isTagsCurrent && isDescriptionCurrent;
  }

  return (
    <WrapTemplateOptions>
      <NameAndFiltersTemplate>
        <TemplateName templateName={templateName} changeTemplateName={changeTemplateName} />
        <TemplateDescription
          templateDescription={templateDescription}
          changeTemplateDescription={changeTemplateDescription}
        />
        <TemplateFolderSelection folders={folders} />
        <ExceptCategoryBlock
          title="Выберите теги шаблона (те продукты, которые он не содержит/не должен содержать):"
          tags={tags}
          category={templateTagsFilters}
          setExceptCategories={selectTemplateTagsFilters}
          categoryIngredients={CATEGORY_INGREDIENTS}
        />
        <TemplateCaloriesBlock>
          <TemplateCalorieTitle>Дневная норма калорий клиентов</TemplateCalorieTitle>
          <Input
            style={{ width: '100%' }}
            placeholder="Среднее количество калорий"
            type="number"
            value={maxCalories}
            onChange={(e) => setMaxCalories(e.target.value)}
          />
        </TemplateCaloriesBlock>
      </NameAndFiltersTemplate>
      <OptionsTemplate>
        <CountDayOfMenuBlock
          selectedDaysCount={countTemplateDays}
          changeDaysCount={onChangeTemplateCountDays}
        />
        <TypeMenuBlock
          sameDaysCount={templateSameDaysCount}
          setSameDaysCount={changeTemplateSameDaysCount}
          selectedDayCount={countTemplateDays}
        />
        <ExceptCategoryBlock
          title="Параметры шаблона:"
          tags={tags}
          category={templateParametersCategories}
          setExceptCategories={setTemplateParametersCategories}
          categoryIngredients={TEMPLATE_PARAMETERS_TAG}
          setGenderValue={setGenderValue}
        />
        <ChooseEatings
          eatings={allEatingsTags}
          chosenEatings={chosenTemplateEatings}
          toggleEating={toggleTemplateEating}
        />
        <TemplateActions
          onGenerate={() => setIsOpenTemplateGenerationValues(true)}
          onClear={onClearTemplateMenuBlock}
          onSave={checkIsTemplateAlreadyExists}
          disabledSaveBtn={disableSaveBtn || loader}
          disabledGenerateBtn={loader}
        />
      </OptionsTemplate>
      <ConfirmPopup
        title="Шаблон с таким именем уже существует"
        text="Перезаписать его?"
        isShow={isShowRewriteTemplatePopup}
        onClose={toggleRewritePopup}
        onApply={onApplyRewrite}
        additionalText="* для создания нового шаблона измените его имя"
      />
      <TemplateGenerationValuesModal
        isOpen={isOpenTemplateGenerationValues}
        onClose={() => setIsOpenTemplateGenerationValues(false)}
        onSubmit={generateTemplateMenu}
      />
    </WrapTemplateOptions>
  );
};

const mapStateToProps = (state) => {
  const {
    templateName,
    templateDescription,
    templateTagsFilters,
    countTemplateDays,
    templateSameDaysCount,
    chosenTemplateEatings,
    menuTemplateGenerator,
    templateParametersCategories,
  } = state.templateGenerator;
  const { tags, allEatingsTags } = state.getTags;
  const { loader } = state.loader;
  const { folders } = state.folders;
  return {
    templateName,
    templateDescription,
    tags,
    templateTagsFilters,
    countTemplateDays,
    templateSameDaysCount,
    chosenTemplateEatings,
    loader,
    menuTemplateGenerator,
    allEatingsTags,
    folders,
    templateParametersCategories,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeTemplateName: (name) => dispatch(changeTemplateName(name)),
  changeTemplateDescription: (description) => dispatch(changeTemplateDescription(description)),
  selectTemplateTagsFilters: (templateTagsFilters) =>
    dispatch(selectTemplateTagsFilters(templateTagsFilters)),
  getTags: () => dispatch(getTags()),
  changeTemplateMenuDays: (countDays) => dispatch(changeTemplateMenuDays(countDays)),
  changeTemplateSameDaysCount: (templateSameDaysCount) =>
    dispatch(changeTemplateSameDaysCount(templateSameDaysCount)),
  generateTemplateMenu: () => dispatch(generateTemplateMenu()),
  saveTemplate: (selectedFolder) => dispatch(saveTemplate(selectedFolder)),
  toggleTemplateEating: (eatingId) => dispatch(toggleTemplateEating(eatingId)),
  setMenuTemplateGenerator: (menu) => dispatch(setMenuTemplateGenerator(menu)),
  setTemplateParametersCategories: (templateTagsFilters) =>
    dispatch(setTemplateParametersCategories(templateTagsFilters)),
  setGenderValue: (genderValue) => dispatch(setGenderValue(genderValue)),
  resetTemplateData: () => dispatch(resetTemplateData()),
  resetChoosedTemplate: () => dispatch(resetChoosedTemplate()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateOptions);

const WrapTemplateOptions = styled.div`
  margin-top: 25px !important;
  width: 75%;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  @media screen and (max-width: 1050px) {
    width: 80%;
    flex-wrap: wrap;
  }
`;

const NameAndFiltersTemplate = styled.div`
  width: 60%;
  @media screen and (max-width: 1250px) {
    width: 50%;
  }
  @media screen and (max-width: 1050px) {
    width: 100%;
  }
`;

const OptionsTemplate = styled.div`
  margin-left: 10px;
  @media screen and (max-width: 1050px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 30px 0px;
  }
`;

const TemplateCaloriesBlock = styled.div`
  margin: 10px 0;
  width: 100%;
`;

const TemplateCalorieTitle = styled.div`
  font-size: 21px;
  margin: 20px 0;
`;



// WEBPACK FOOTER //
// ./src/Components/TemplateGenerator/TemplateOptions.jsx